const Hero = () => {
    //const src = 'https://cdn.content.careerhub.com.au/UC/component-images/hero.jpg';

    return (
        <div className="text-center pb-5 bg-alt position-relative z-2 d-none">
            <div className="position-relative uc-hero-container mx-auto">
                {/*<ImageDisplay
                    src={src}
                    width="100%"
                    imgClassName="shadow uc-hero-banner"
                    alt="hero banner"
                />*/}
                <div className="position-absolute uc-hero-text-container d-flex flex-column justify-content-center">
                    <div className="uc-hero-text-container-inner d-inline">
                        <div className="display-4 uc-hero-text" style={{ fontWeight: 400 }}>
                            Careers UC Employers Portal
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Hero;
